import { Action } from '@ngrx/store';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface HydratedState {}

export function reducer(state = false, action: Action): HydratedState {
  return state;
}
